import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

// Good
const get = function ($, projectId, cfsiId = null) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/${cfsiId ? "cfsis/" + cfsiId : projectId + "/cfsis"}`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getAllCfcis = function () {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/cfsis`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getListAllActions = function () {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/cfsis/actions`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getListAllProjectActions = function (projectId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/${projectId}/cfsis/actions`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getByInspection = function (projectId, inspectionId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/${projectId}/inspections/${inspectionId}/cfsis`)
      .then(response => {
        resolve(response.data)
      })
      .catch(exception => {
        reject(exception)
      })
  })
}

const create = function ($, projectId, cfsi) {
  return new Promise((resolve, reject) => {
    HTTP.post(`projects/${projectId}/cfsis`, cfsi)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const update = function ($, cfsiId, data) {
  return new Promise((resolve, reject) => {
    HTTP.patch(`/projects/cfsis/${cfsiId}`, data)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const remove = function ($, cfsiId) {
  return new Promise((resolve, reject) => {
    HTTP.delete(`/projects/cfsis/${cfsiId}`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const close = function ($, cfsiId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/projects/cfsis/${cfsiId}/close`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const closeAction = function ($, actionId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/projects/cfsis/action/${actionId}/close`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const createAction = function (cfsiId, data) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/projects/cfsis/${cfsiId}/action`, data)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getAllActions = function (cfsiId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/cfsis/${cfsiId}/action`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const updateAction = function (actionID, data) {
  return new Promise((resolve, reject) => {
    HTTP.put(`projects/cfsis/action/${actionID}`, data)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const deleteAction = function (actionID) {
  return new Promise((resolve, reject) => {
    HTTP.delete(`projects/cfsis/action/${actionID}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        if (err.response && err.response.status === 403) {
          // alert("Access denied: You do not have permission to access this resource.")
          this.$store.commit("app/message", {
            msg: this.$t("messages.error.permission_denied"),
            color: "error"
          })
        } else {
          reject(err)
        }
      })
  })
}

const getSignatures = function (cfsiId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/cfsis/${cfsiId}/signatures`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const postSignature = function (cfsiId, imageData) {
  if (imageData) {
    const formData = new FormData()
    formData.append("image", imageData)

    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/cfsis/${cfsiId}/signatures`, formData)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  } else {
    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/cfsis/${cfsiId}/signatures`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const getActionSignatures = function (actionId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/cfsis/action/${actionId}/signatures`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const postActionSignature = function (actionId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/projects/cfsis/action/${actionId}/signatures`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

// const close = function ($, cfsiId) {
//   return new Promise((resolve, reject) => {
//     HTTP.post(`projects/cfsis/${cfsiId}/close`)
//       .then(response => resolve(response.data))
//       .catch(err => {
//         return reject(err)
//       })
//   })
// }

export default {
  get,
  getAllCfcis,
  getListAllActions,
  getListAllProjectActions,
  getByInspection,
  create,
  update,
  remove,
  close,
  closeAction,
  createAction,
  getAllActions,
  updateAction,
  deleteAction,
  postSignature,
  getSignatures,
  postActionSignature,
  getActionSignatures
}
